import { PerimetreService } from './../../entities/perimetre/perimetre.service';
import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, ViewChildren, QueryList, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { ListOuvrage } from 'src/app/entities/ouvrage/listouvrage.model';
import { Ouvrage } from 'src/app/entities/ouvrage/ouvrage.model';
import { Acteur } from 'src/app/entities/acteur/acteur.model';
import { Adresse } from 'src/app/entities/adresse/adresse.model';
import * as _ from 'lodash';
import { Declaration } from 'src/app/entities/declaration/declaration.model';
import { OuvrageService } from 'src/app/entities/ouvrage/ouvrage.service';
import { LexTypeSaisieCoor } from 'src/app/entities/lex-type-saisie-coor/lex-type-saisie-coor.model';
import { LexTypeSaisieCoorService } from 'src/app/entities/lex-type-saisie-coor/lex-type-saisie-coor.service';
import { AlertService } from 'src/app/shared/alert/alert.service';
import { LexSystemeReferenceSpatial } from 'src/app/entities/lex-systeme-reference-spatial/lex-systeme-reference-spatial.model';
import { LexSystemeReferenceSpatialService } from 'src/app/entities/lex-systeme-reference-spatial/lex-systeme-reference-spatial.service';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AdresseService } from 'src/app/entities/adresse/adresse.service';
import { ContactService } from 'src/app/entities/contact/contact.service';
import { ActeurService } from 'src/app/entities/acteur/acteur.service';
import { Perimetre } from 'src/app/entities/perimetre/perimetre.model';
import { CommuneService } from 'src/app/entities/commune/commune.service';
import { LexRelationService } from 'src/app/entities/lex-relation/lex-relation.service';
import { LexRelation } from 'src/app/entities/lex-relation/lex-relation.model';

@Component({
    selector: 'dup-ouvrage',
    templateUrl: './ouvrageform.component.html',
    styleUrls: [
      '../forms.css'
    ]
  })
  export class OuvrageFormComponent implements OnInit, OnChanges, OnDestroy {

    lextypesaisiecoor: LexTypeSaisieCoor[];
    lexsrs:LexSystemeReferenceSpatial[];
    perimetre:Perimetre[];

    // concerne de l'eau
    @Input() isEau: Boolean = false;
    // concerne les forages domestiques
    @Input() isDomestique: Boolean = false;

    @Input() plusieursOuvrages: Boolean = false;

    // roles du declarant
    @Input() isDeclarantProprietaire: Boolean = false;
    @Output() isDeclarantProprietaireChange = new EventEmitter();
    @Input() isDeclarantExploitant: Boolean = false;
    @Output() isDeclarantExploitantChange = new EventEmitter();
    @Input() isDeclarantMOE: Boolean = false;
    @Output() isDeclarantMOEChange = new EventEmitter();

    //declarant
    @Input() declarant: Acteur;

    @Input() declaration: Declaration;

    @ViewChildren("ouvWarn") ouvWarns:QueryList<ElementRef>;
    @ViewChildren("ouvName") ouvNames:QueryList<ElementRef>;

    //liste des ouvrages de la déclaration
    @Input() declarationOuvrages: ListOuvrage;

    isSumOK:Boolean = true;

    //prise en compte de chaque changement pour la carto
    tick:number = 0;

    routeSub: any;

    navigationSubscription: Subscription;

    /** La liste des type de relation entre les ouvrages d'une même declaration */
    lexrelations: LexRelation[] = [];

    //current
    index:number;
    ouvrageForm: Ouvrage;
    acteur:Acteur;
    acteurName:String = "";
    acteurType:string = "";
    isIdent:Boolean = false;
    isIdentMap:Map<String, Boolean>;
    isSame:Boolean = true;
    coord_ok: boolean = true;

    @Input() acteursFacultatifs:Boolean;

    duplicateNomUsuel:Set<string> = new Set();


    prelevementIsOK = true; // si > 1000 alors pas OK

    /** Nom de l'ouvrage pour lequel un formulaire est ouvert */
    nomOuvrageFormulaire: string;

    /** L'etape courante de la declaration de l'ouvrage (Loclaisation, Caracteristique, MOE, Proprietaire, Foreur et Aquifere) */
    etape: string = '';

    /** Le volume total d'eau prélevé par l'ensemble des ouvrages de la déclaration */
    totalPrelevementOuvrage: number;

    afficherFormulaireNomOuvrage: boolean = true;
      localiserOuvrage: boolean = false;

      /** Attribut utilisé pour determiner s'il faut afficher la carte ou le fomulaire de localisation. */
      displayCarte: boolean = false;

      localisationOuvrageRenseigne = false;
      caracteristiquesValides = false;

      declarationOuvrageEnCours: boolean = false;

      proposerAjouterOuvrage: boolean = false;

      isCoordonneeCarteValide = true;
  isCoordonneeFormulaireValide = true;

    constructor(
        private ouvrageService: OuvrageService,
        private lexTypeSaisieCoorService: LexTypeSaisieCoorService,
        private lexSystemeReferenceSpatialService: LexSystemeReferenceSpatialService,
        private lexRelationService: LexRelationService,
        private perimetreService: PerimetreService,
        private adresseService: AdresseService,
        private contactService: ContactService,
        private acteurService: ActeurService,
        private communeService: CommuneService,
        private alertService: AlertService,
        private route: ActivatedRoute,
        private router: Router
    ) {
      this.ouvrageForm = new Ouvrage();
      this.perimetre = [];
      this.ouvrageForm.adresse = new Adresse();
      this.index = 0;
      this.navigationSubscription = this.router.events.subscribe((e: any) => {
          // If it is a NavigationEnd event re-initalise the component
          if (e instanceof NavigationEnd) {
            this.loadOuvrages();
          }
        });
        this.isIdentMap = new Map();

      if(!this.isDeclarantMOE) {
        this.ouvrageForm.acteurMoe = new Acteur();
      }

      if(!this.isDeclarantProprietaire) {
        this.ouvrageForm.acteurProprio = new Acteur();
      }

      if(!this.isDeclarantExploitant) {
        this.ouvrageForm.acteurForeur = new Acteur();
      }
    }

    ngOnInit(): void {
        if (sessionStorage.getItem('typeReglementation') !== null && sessionStorage.getItem('typeReglementation') == 'FORDOM'){
          this.isEau = true;
        }
        this.lexTypeSaisieCoorService.query()
            .subscribe((res) => { this.lextypesaisiecoor = res; }, (res) => this.onError(res));
        this.lexSystemeReferenceSpatialService.query()
            .subscribe((res) => { this.lexsrs = res; }, (res) => this.onError(res));
        this.perimetreService.query()
            .subscribe((res) => { this.perimetre = res;}, (res) => this.onError(res));
        this.lexRelationService.query()
            .subscribe((res) => {
              res.forEach(rel => {
                if(rel.valide) this.lexrelations.push(rel);
              });
            }, (res) => this.onError(res));

            this.etape = 'Nom';    
    }

    ngOnChanges(changes: SimpleChanges): void {
      for (let propName in changes) {
        if(propName == 'plusieursOuvrages') {
          if(!this.declaration.plusieursOuvrages) {
            this.declarationOuvrages.ouvrages = this.declarationOuvrages.ouvrages.slice(0,1);
          }
          this.tick++;
        }
      }
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
        this.navigationSubscription.unsubscribe();
    }

    // gestion des erreurs de communication
    private onError(error: any) {
        this.alertService.error(error.message, null, null);
    }

    loadOuvrages() {
        this.routeSub = this.route.params.subscribe((params) => {
          if (params['id']) {
              this.ouvrageService.findByDeclaration(params['id']).subscribe((res) => {
                res.forEach(ouvrage => {
                  if (ouvrage.acteurMoeId) {
                    this.acteurService.find(ouvrage.acteurMoeId).subscribe((res) => {
                      if (res.email == this.declarant.email)
                      {
                        this.isDeclarantMOE = true;
                        this.isDeclarantMOEChange.emit(this.isDeclarantMOE);
                      } else {
                        ouvrage.acteurMoe = res;
                        if (res.contactId)
                          this.contactService.find(res.contactId).subscribe((res) =>ouvrage.acteurMoe.contact = res);
                        if (res.adresseId)
                          this.adresseService.find(res.adresseId).subscribe((res) => ouvrage.acteurMoe.adresse = res);
                      }
                    });
                  }
                  if (ouvrage.acteurProprioId) {
                    this.acteurService.find(ouvrage.acteurProprioId).subscribe((res) => {
                      if (res.email == this.declarant.email)
                      {
                        this.isDeclarantProprietaire = true;
                        this.isDeclarantProprietaireChange.emit(this.isDeclarantProprietaire);
                      } else {
                        ouvrage.acteurProprio = res;
                        if (res.contactId)
                          this.contactService.find(res.contactId).subscribe((res) =>ouvrage.acteurProprio.contact = res);
                        if (res.adresseId)
                          this.adresseService.find(res.adresseId).subscribe((res) => ouvrage.acteurProprio.adresse = res);
                      }
                    });
                  }
                  if (ouvrage.acteurForeurId) {
                    this.acteurService.find(ouvrage.acteurForeurId).subscribe((res) => {
                      if (res.email == this.declarant.email)
                      {
                        this.isDeclarantExploitant = true;
                        this.isDeclarantExploitantChange.emit(this.isDeclarantExploitant);
                      } else {
                        ouvrage.acteurForeur = res;
                        if (res.contactId)
                          this.contactService.find(res.contactId).subscribe((res) =>ouvrage.acteurForeur.contact = res);
                        if (res.adresseId)
                          this.adresseService.find(res.adresseId).subscribe((res) => ouvrage.acteurForeur.adresse = res);
                      }
                    });
                  }
                  if (ouvrage.adresseId) {
                    this.adresseService.find(ouvrage.adresseId).subscribe((res) => {
                      ouvrage.adresse = res;
                      this.communeService.find(res.communeInseeCom).subscribe((res) => ouvrage.adresse.commune = res);
                    });
                  }
                  if (ouvrage.x && ouvrage.y){
                    this.coord_ok = true;
                  }

                  this.declarationOuvrages.ouvrages.push(ouvrage);
                  this.tick++;
                  this.duplicateNomUsuel.add(ouvrage.nomUsuel);
                });
              });
            }
        });
    }

    same(event) {
      if(this.isSame && this.declarationOuvrages.ouvrages.length>0) {
        for (let i = 1; i < this.declarationOuvrages.ouvrages.length; i++) {
          this.clone(this.declarationOuvrages.ouvrages[i]);
        }
        this.checkPrelevement();
      }
    }

      clone(ouvrageToClone:Ouvrage) {
        let ouvrage: Ouvrage = this.declarationOuvrages.ouvrages[0];
        ouvrageToClone.acteurMoe = _.cloneDeep(ouvrage.acteurMoe);
        ouvrageToClone.acteurMoeId = _.clone(ouvrage.acteurMoeId);
        ouvrageToClone.acteurProprio = _.cloneDeep(ouvrage.acteurProprio);
        ouvrageToClone.acteurProprioId = _.clone(ouvrage.acteurProprioId);
        ouvrageToClone.acteurForeur = _.cloneDeep(ouvrage.acteurForeur);
        ouvrageToClone.acteurForeurId = _.clone(ouvrage.acteurForeurId);
        ouvrageToClone.longeur = _.clone(ouvrage.longeur);
        ouvrageToClone.diametre = _.clone(ouvrage.diametre);
        ouvrageToClone.natureOuvrageId = _.clone(ouvrage.natureOuvrageId);
        ouvrageToClone.natureOuvrageLibelle = _.clone(ouvrage.natureOuvrageLibelle);
        ouvrageToClone.directionId = _.clone(ouvrage.directionId);
        ouvrageToClone.directionLibelle = _.clone(ouvrage.directionLibelle);
        ouvrageToClone.azimut = _.clone(ouvrage.azimut);
        ouvrageToClone.pendage = _.clone(ouvrage.pendage);
        ouvrageToClone.presenceMargelle = _.clone(ouvrage.presenceMargelle);
        ouvrageToClone.conformeNorme = _.clone(ouvrage.conformeNorme);
        ouvrageToClone.prelevement = _.clone(ouvrage.prelevement);
        ouvrageToClone.debit = _.clone(ouvrage.debit);
        ouvrageToClone.reseauInterne = _.clone(ouvrage.reseauInterne);
        ouvrageToClone.rejetPluviales = _.clone(ouvrage.rejetPluviales);
        ouvrageToClone.rejetUsees = _.clone(ouvrage.rejetUsees);
        ouvrageToClone.codeNappe = _.clone(ouvrage.codeNappe);
        ouvrageToClone.natureNappe = _.clone(ouvrage.natureNappe);
        ouvrageToClone.nomNappe = _.clone(ouvrage.nomNappe);
        ouvrageToClone.commentaireNappe = _.clone(ouvrage.commentaireNappe);
      }

      coord_valide(coordXY:boolean){
        this.coord_ok = coordXY;
      }

      validateLocalisation(ouvrage:Ouvrage) {
        let baseOuvrage = ouvrage != null 
                          && ouvrage.modeXYId != null 
                          && ouvrage.srsId != null
                          && ouvrage.x != null 
                          && ouvrage.y != null 
                          && ouvrage.typeLocalisationId != null
                          && ouvrage.adresse != null 
                          && ouvrage.adresse.communeInseeCom != null;
        return baseOuvrage && this.isCoordonneeValide();
      }

  validateCarac(ouvrage:Ouvrage) {
    let baseOuvrage:Boolean = ouvrage != null && ouvrage != undefined && ouvrage.longeur != null && ouvrage.longeur <10000 && ouvrage.natureOuvrageId != null && ouvrage.directionId != null;
    if(baseOuvrage) {
        if(ouvrage.directionId == 2400){
        baseOuvrage = baseOuvrage && ouvrage.azimut != null && ouvrage.azimut>=0 && ouvrage.azimut<360 && ouvrage.pendage != null && ouvrage.pendage>=0 && ouvrage.pendage <= 90;
      }
    }
        
    if ( this.declaration.fonctionId >= 5500 && this.declaration.fonctionId <= 5599 ) {
      baseOuvrage = baseOuvrage && ouvrage.debit != null && ouvrage.debit >= 0 && ouvrage.prelevement != null && ouvrage.prelevement >= 0 && (ouvrage.prelevement < 1000 || (sessionStorage.getItem("typeReglementation") !== null && sessionStorage.getItem("typeReglementation") != 'FORDOM') );
    }

    if(this.isDomestique) {
      baseOuvrage = baseOuvrage && ouvrage.presenceMargelle != null 
                                && ouvrage.conformeNorme != null 
                                && ouvrage.reseauInterne != null 
                                && ouvrage.rejetUsees != null 
                                && ouvrage.rejetPluviales != null
                                && ouvrage.diametre >= 100 && ouvrage.diametre < 9999;
      
      // Le volume de prelevement d'un ouvrage domestique ne peut pas dépasser les 1000 m3
      if(this.totalPrelevementOuvrage > 1000) {
        baseOuvrage = false;
      }
  
      // Le volume d'eau prélevé par l'ouvrage ne doit pas dépasser celui rensiegné dans la déclaration pour un forage domestique
      else if(this.totalPrelevementOuvrage > this.declaration.prelevement) {
        baseOuvrage = false;
      }
    }
        
    return baseOuvrage;
  }

      validateActeur(acteur:Acteur) {
        let baseActeur = acteur != null && acteur != undefined;
        if(baseActeur) {
          baseActeur = baseActeur && acteur.statutJuridiqueId != null && acteur.email != null;
          if (acteur.adresse) {
            baseActeur = baseActeur && acteur.adresse.pays != null;
            if (acteur.adresse.pays == "France") {
              baseActeur = baseActeur && acteur.adresse.communeInseeCom != null;
            } else {
              baseActeur = baseActeur && acteur.adresse.lieuDit != null;
            }
          } else {
            baseActeur = false;
          }
          if (acteur.statutJuridiqueId == 3800) {
            baseActeur = baseActeur && acteur.siretEtab != null && acteur.raisonSocialeEtab != null;
            const regex = new RegExp('^[\\0-9]{14}$', 'g');
            baseActeur = acteur.siretEtab.match(regex) != null
          }
          
          if (acteur.email != undefined){
            const regex = new RegExp('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$', 'g');
            baseActeur = baseActeur && acteur.email.match(regex) != null;
          }else{
            baseActeur = false;
          }
        }
        return baseActeur;
      }

      cancelOuvrage(ouvrage: Ouvrage) {
        let index = this.declarationOuvrages.ouvrages.indexOf(ouvrage);
        if (ouvrage.id) {
          this.ouvrageService.delete(ouvrage.id).subscribe(res => {});
        }
        this.declarationOuvrages.ouvrages.splice(index,1);
        this.tick++;
        this.computeDuplicate()

        this.declaration.plusieursOuvrages = this.declarationOuvrages.ouvrages.length > 1;

        this.displayCarte = false;
        this.afficherFormulaireNomOuvrage = true;

        this.etape = 'Nom';
      }

      changeName(ouvrage:Ouvrage) {
       let index = this.declarationOuvrages.ouvrages.indexOf(ouvrage);
       let element = this.ouvNames.find((item, idx) => {
          return idx === index;
        }).nativeElement;
        element.style.display='inline-block';
        element.focus();
        this.ouvWarns.find((item, idx) => {
          return idx === index;
        }).nativeElement.style.display = 'none';
      }

      computeDuplicate() {
        const set = new Set();
        this.duplicateNomUsuel.clear();

        this.declarationOuvrages.ouvrages.forEach(ouv => {
          ouv.nomUsuel = ouv.nomUsuel?.trim();
          if (set.has(ouv.nomUsuel)) {
            this.duplicateNomUsuel.add(ouv.nomUsuel);
          } else {
            set.add(ouv.nomUsuel);
          }
        });
      }

      closeInput(ouvrage:Ouvrage){
        let index = this.declarationOuvrages.ouvrages.indexOf(ouvrage);
        this.ouvNames.find((item, idx) => {
           return idx === index;
         }).nativeElement.style.display = 'none';
        this.ouvWarns.find((item, idx) => {
          return idx === index;
        }).nativeElement.style.display = 'inline-block';
      }

        // Valeurs possibles pour acteurName : Maitre oeuvre, Propriétaire et Foreur
        ident(acteurName: string) {

          if(acteurName === 'Maitre oeuvre') {
            this.ouvrageForm.acteurMoe = this.declaration.acteurMoa;
            this.ouvrageForm.acteurMoeId = this.declaration.acteurMoaId;
          }
          else if(acteurName === 'Proprietaire') {
            this.ouvrageForm.acteurProprio = this.declaration.acteurMoa;
            this.ouvrageForm.acteurProprioId = this.declaration.acteurMoaId;
          }
          else if(acteurName === 'Foreur') {
            this.ouvrageForm.acteurForeur = this.declaration.acteurMoa;
            this.ouvrageForm.acteurForeurId = this.declaration.acteurMoaId;
          }
        }

  checkPrelevement() {
    this.totalPrelevementOuvrage = 0;
    this.declarationOuvrages.ouvrages.forEach(ouvrage => {
      if(ouvrage.prelevement) {
        this.totalPrelevementOuvrage += ouvrage.prelevement
      };
    });
  }

      getSrs():string {
        return this.ouvrageForm && this.ouvrageForm.srsId ?"EPSG:" + _.find(this.lexsrs, ['id', this.ouvrageForm.srsId]).epsg:"";
      }

      isCarte():Boolean {
        let isCarte = false;
        let lextypesaisiecoorCarte = _.find(this.lextypesaisiecoor, ['id', this.ouvrageForm.typeSaisieCoorId]);
        if (lextypesaisiecoorCarte && lextypesaisiecoorCarte.mnemo == 'CARTE') isCarte = true;
        return isCarte;
      }

      

  /**
  * Méthode appelée par le bouton "Annuler" depuis le formulaire de renseignement du nom de l'ouvrage.
  * Au clic sur le bouton, l'utilisateur est redirigé vers l'écran de tableau de bord.
  */
  annulerDeclaration(): void {
    this.router.navigate(['']);
  }

  /**
  * Méthode permettant d'ajouter un ouvrage supplémentaire à la déclaration.
  */
  ajouterOuvrage(): void {
    this.afficherFormulaireNomOuvrage = false;
    this.localiserOuvrage = true;
    this.displayCarte = true;
    this.etape = 'Localisation';
    this.duplicateNomUsuel.add(this.ouvrageForm.nomUsuel);
  }

  /**
   * Méthode appelée au clic sur le slider de la fenetre de localisation. 
   * La méthode inverse la valeur de l'attribut displayCarte permettant de passer de la sasiie de coordonnée par la carte
   * à la saisie de coordonnée par le fomulaire et inversement.
   */
  changerSaisieCoordonnees() {
    this.displayCarte = !this.displayCarte;
  }

  /**
   * Méthode appelée par le bouton "Suivant" du fomulaire de saisie des coordonnées de l'ouvrage.
  */
  remplirCoordonnees(): void {
    this.localiserOuvrage = false;
    this.localisationOuvrageRenseigne = true;

    this.etape = 'Caracteristique';

    this.declarationOuvrageEnCours = true;
  }

  /**
   * Méthode controlant l'activation du bouton "Suivant" de l'écran de saisie des caractéristiques de l'ouvrage.
   * La méthode vérifie que les valeurs saisies sont dans la plage de validité.
   * 
   * @returns 
   */
  isCaracteristiquesValides(): boolean {
        let caracteristiquesValide: boolean = this.ouvrageForm.longeur != null
                                              && this.ouvrageForm.longeur < 10000
                                              && this.ouvrageForm.natureOuvrageId != null
                                              && this.ouvrageForm.directionId != null;
        if(this.ouvrageForm.directionId == 2400) {
          caracteristiquesValide = caracteristiquesValide && this.ouvrageForm.azimut != null
                                                          && this.ouvrageForm.azimut >= 0
                                                          && this.ouvrageForm.azimut < 360
                                                          && this.ouvrageForm.pendage != null
                                                          && this.ouvrageForm.pendage >= 0
                                                          && this.ouvrageForm.pendage <= 90;
        }
        return caracteristiquesValide;
      }

      creerNouvelOuvrage() {
        this.declaration.plusieursOuvrages = true;
        this.declarationOuvrageEnCours = false;
        this.afficherFormulaireNomOuvrage = true;
        this.proposerAjouterOuvrage = false;

        this.ouvrageForm = new Ouvrage();
        this.ouvrageForm.adresse = new Adresse();

        this.etape = 'Nom';
      }

  /**
   * Méthode appelée quand l'utilisateur clic sur le bouton "Précédent" depuis l'écran de saisie de la localisation de l'ouvrage.
   * La méthode permet à l'utilisateur de revenir à l'étape de saisie du nom de l'ouvrage.
   */
  annulerLocalisation(): void {
    this.etape = 'Nom';

    this.cancelOuvrage(this.ouvrageForm);
  }

  /**
   * Méthode appelée quand l'utilisateur clic sur le le bouton "Précédent" depuis l'écran de saisie des caractéristiques de l'ouvrage.
   * La méthode permet à l'utilisateur de revenir à l'étape de saisie de la localisation de l'ouvrage.
   */
  annulerCaracteristique() {
    this.etape = 'Localisation';
  }

  /**
   * Méthode appelée quand l'utilisateur clic sur le le bouton "Précédent" depuis l'écran de saisie des information du MOE.
   * La méthode permet à l'utilisateur de revenir à l'étape de saisie des caractéristiques de l'ouvrage.
   */
  annulerMaitreOeuvre(): void {
    this.etape = 'Caracteristique';
  }

  /**
   * Méthode appelée quand l'utilisateur clic sur le le bouton "Précédent" depuis l'écran de saisie des informations du propriétaire.
   * La méthode permet à l'utilisateur de revenir à l'étape précédente.
   * Si le declarant n'est pas le MOE, l'utilisateur revient à l'étape de saisie des informations du MOE.
   * Sinon l'utilisateur revient à l'écran de saisie des caractéristiques de l'ouvrage.
   */
  annulerProprietaire(): void {
    if(!this.isDeclarantMOE) {
      this.etape = 'MOE';
    }
    else {
      this.etape = 'Caracteristique';
    }
  }

  /**
   * Méthode appelée quand l'utilisateur clic sur le bouton "Précédent" depuis l'écran de saisie des informations du foreur.
   * La méthode permet à l'utilisateur de revenir à l'étape précédente.
   * Si le déclarant n'est pas le propriétaire, l'utilisateur revient à l'étape de saisie des informations du propriétaire.
   * Si le déclarant n'est pas le MOE, l'utilisateur revient à l'étape de saisie des informations du MOE.
   * Sinon l'utilisateur revient à l'écran de saisie des caractéristiques de l'ouvrage.
   */
  annulerForeur() {
    if(!this.isDeclarantProprietaire) {
      this.etape = 'Proprietaire';
    }
    else if(!this.isDeclarantMOE) {
      this.etape = 'MOE';
    }
    else {
      this.etape = 'Caracteristique';
    }
  }

  /**
   * Méthode appelée quand l'utilisateur clic sur le le bouton "Précédent" depuis l'écran de saisie des caractéristiques de l'aquifere.
   * La méthode permet à l'utilisateur de revenir à l'étape précédente.
   * Si le declarant n'est pas le foreur, l'utilisateur revient à l'étape de saisie des informations du foreur.
   * Si le declarant n'est pas le proprietaire de l'ouvrage, l'utilisateur revient à l'étape de saisie des informations du propriétaire
   * Si le declarant n'est pas le MOE, l'utilisateur revient à l'étape de saisie des informations du MOE.
   * Sinon l'utilisateur revient à l'étape de saisie des caractéristiques de l'ouvrage.
   */
  annulerAquifere(): void {
    if(!this.isDeclarantExploitant) {
      this.etape = 'Foreur';
    }
    else if(!this.isDeclarantProprietaire) {
      this.etape = 'Proprietaire';
    }
    else if(!this.isDeclarantMOE) {
      this.etape = 'MOE';
    }
    else {
      this.etape = 'Caracteristique';
    }
  }

  /**
   * Méthode appelée quand l'utilisateur clic sur le bouton "Terminer".
   * La méthode va faire passer l'attribut etape à la valeur "Termine" et va créer une nouvelle instance d'Ouvrage pour l'attribut ouvrageForm.
   */
  terminerOuvrage() {
    this.proposerAjouterOuvrage = true;
    this.afficherFormulaireNomOuvrage = false;

    this.ouvrageForm = new Ouvrage();
    this.declarationOuvrageEnCours = false;

    this.etape = 'Termine';
  }

  /**
   * Méthode controlant l'activation du bouton "Suivant" de l'écran de saisie du nom.
   * Pour etre valide, le nom doit etre non vide.
   * Si c'est le deuxieme ouvrage de la déclaration, la relation entre les ouvrages doit aussi être renseigné pour que le bouton "Suivant" soit actif.
   * 
   * @returns true si le nom de l'ouvrage est valide, false sinon
   */
  nouvelOuvrageValide(): boolean {
    let ouvrageValide: boolean = this.ouvrageForm != null 
                                 && this.ouvrageForm.nomUsuel != null
                                 && this.ouvrageForm.nomUsuel.trim() != "";
    if(this.declarationOuvrages.ouvrages.length >= 1) {
      ouvrageValide = ouvrageValide && this.declaration.relationId != null;
    }

    return ouvrageValide;
  }

  /**
   * Méthode controlant la validité des coordonnées saisies pour l'ouvrage, que ces coordonnées soient saisie via la carte ou le formulaire.
   * 
   * @returns true si les coordonnées sont valies, false sinon.
   */
  isCoordonneeValide() {
    return this.isCoordonneeCarteValide && this.isCoordonneeFormulaireValide;
  }

  /**
   * Méthode permettant de recupérer le signal émit par le Component OlMapComponent et contenant un booleen indiquant si les coordonnées saisies sont valides.
   * 
   * @param coordonneeCarteValide le booléen emit par OlMapComponent.
   */
  validerCoordonneeCarte(coordonneeCarteValide) {
    this.isCoordonneeCarteValide = coordonneeCarteValide;
  }

  /**
   * Méthode permettant de recupérer le signal émit par le Component LocalisationFormComponent et contenant un booleen indiquant si les coordonnées saisies sont valides.
   * 
   * @param coordonneeFormulaireValide le booléen emit par LocalisationFormComponent.
   */
  validerCoordonneeFormulaire(coordonneeFormulaireValide) {
    this.isCoordonneeFormulaireValide = coordonneeFormulaireValide;
  }

  /**
   * Méthode permettant de selectionner le style CSS à appliquer à la ligne Localisation du résumé de l'ouvrage.
   * La classe CSS est sélectionné à partir de l'étape courante de la déclaration de l'ouvrage.
   * Si l'étape courante est celle de la déclaration de la Loclaisation, la classe est 'suivi-declaration-ouvrage-apparence-actif'
   * Sinon, la classe est 'suivi-declaration-ouvrage-apparence-passe'
   * 
   * @returns la classe CSS correspondant au context
   */
  choisirClasseCssLocalisation() {
    if(this.etape === 'Localisation') {
      return 'suivi-declaration-ouvrage-apparence-actif';
    }
    else {
      return 'suivi-declaration-ouvrage-apparence-passe';
    }
  }

  /**
   * Méthode permettant de selectionner le style CSS à appliquer à l'icone du crayon dans le résumé de l'ouvrage pour la ligne Localisation.
   * La classe CSS est sélectionné à partir de l'étape courante de la déclaration de l'ouvrage.
   * Si l'étape courante est celle de la déclaration de la Localisation, la classe est 'crayon-actif'
   * Sinon la classe est 'crayon-passe'
   * 
   * @returns la classe CSS correspondant au context
   */
  choisirClasseCssLocalisationCrayon() {
    if(this.etape === 'Localisation') {
      return 'crayon-actif';
    }
    else {
      return 'crayon-passe';
    }
  }

  /**
   * Méthode permettant de selectionner le style CSS à appliquer à la ligne Caracteristique du résumé de l'ouvrage.
   * La classe CSS est sélectionné à partir de l'étape courante de la déclaration de l'ouvrage.
   * Si l'étape courante est celle de la déclaration du caracteristique, la classe est 'suivi-declaration-ouvrage-apparence-actif'
   * Si l'étape courante est antérieur à la déclaration du caracteristique (Localisation), la classe est 'suivi-declaration-ouvrage-apparence-inactif'
   * Si l'étape courante est postérieur à la déclaration du caracteristique (declaration des acteurs ou de l'aquifere), la classe est 'suivi-declaration-ouvrage-apparence-passe'
   * 
   * @returns la classe CSS correspondant au context
   */
  choisirClasseCssCaracteristique() {
    if(this.etape === 'Localisation') {
      return 'suivi-declaration-ouvrage-apparence-inactif';
    }
    else if (this.etape === 'Caracteristique') {
      return 'suivi-declaration-ouvrage-apparence-actif';
    }
    else {
      return 'suivi-declaration-ouvrage-apparence-passe';
    }
  }

  /**
   * Méthode permettant de selectionner le style CSS à appliquer à l'icone du crayon dans le résumé de l'ouvrage pour la ligne Caracteristique.
   * La classe CSS est sélectionné à partir de l'étape courante de la déclaration de l'ouvrage.
   * Si l'étape courante est celle de la déclaration du Caracteristique, la classe est 'crayon-actif'
   * Si l'étape courante est antérieur à la déclaration du Caracteristique (Localisation), la classe est 'crayon-inactif'
   * Si l'étape courante est postérieur à la déclaration du Caracteristique (declaration des acteurs ou de l'aquifere), la classe est 'crayon-passe'
   * 
   * @returns la classe CSS correspondant au context
   */
  choisirClasseCssCaracteristiqueCrayon() {
    if(this.etape === 'Localisation') {
      return 'crayon-inactif';
    }
    else if (this.etape === 'Caracteristique') {
      return 'crayon-actif';
    }
    else {
      return 'crayon-passe';
    }
  }

  /**
   * Méthode permettant de selectionner le style CSS à appliquer à la ligne MOE du résumé de l'ouvrage.
   * La classe CSS est sélectionné à partir de l'étape courante de la déclaration de l'ouvrage.
   * Si l'étape courante est celle de la déclaration du MOE, la classe est 'suivi-declaration-ouvrage-apparence-actif'
   * Si l'étape courante est antérieur à la déclaration du MOE (Localisation ou Caracteristique), la classe est 'suivi-declaration-ouvrage-apparence-inactif'
   * Si l'étape courante est postérieur à la déclaration du MOE (declaration des autres acteurs ou de l'aquifere), la classe est 'suivi-declaration-ouvrage-apparence-passe'
   * 
   * @returns la classe CSS correspondant au context
   */
  choisirClasseCssMoe() {
    if(this.etape === "MOE") {
      return 'suivi-declaration-ouvrage-apparence-actif';
    }
    else if(this.etape === 'Localisation' || this.etape === 'Caracteristique') {
      return 'suivi-declaration-ouvrage-apparence-inactif';
    }
    else {
      return 'suivi-declaration-ouvrage-apparence-passe';
    }
  }

  /**
   * Méthode permettant de selectionner le style CSS à appliquer à l'icone du crayon dans le résumé de l'ouvrage pour la ligne MOE.
   * La classe CSS est sélectionné à partir de l'étape courante de la déclaration de l'ouvrage.
   * Si l'étape courante est celle de la déclaration du MOE, la classe est 'crayon-actif'
   * Si l'étape courante est antérieur à la déclaration du MOE (Localisation ou Caracteristique), la classe est 'crayon-inactif'
   * Si l'étape courante est postérieur à la déclaration du MOE (declaration des autres acteurs ou de l'aquifere), la classe est 'crayon-passe'
   * 
   * @returns la classe CSS correspondant au context
   */
  choisirClasseCssMoeCrayon() {
    if(this.etape === "MOE") {
      return 'crayon-actif';
    }
    else if(this.etape === 'Localisation' || this.etape === 'Caracteristique') {
      return 'crayon-inactif';
    }
    else {
      return 'crayon-passe';
    }
  }

  /**
   * Méthode permettant de selectionner le style CSS à appliquer à la ligne Propriétaire du résumé de l'ouvrage.
   * La classe CSS est sélectionné à partir de l'étape courante de la déclaration de l'ouvrage.
   * Si l'étape courante est celle de la déclaration du proprietaire, la classe est 'suivi-declaration-ouvrage-apparence-actif'
   * Si l'étape courante est antérieur à la déclaration du proprietaire (Localisation, Caracteristique ou MOE), la classe est 'suivi-declaration-ouvrage-apparence-inactif'
   * Si l'étape courante est postérieur à la déclaration du proprietaire (declaration des autres acteurs ou de l'aquifere), la classe est 'suivi-declaration-ouvrage-apparence-passe'
   * 
   * @returns la classe CSS correspondant au context
   */
  choisirClasseCssProprietaire() {
    if(this.etape === 'Proprietaire') {
      return 'suivi-declaration-ouvrage-apparence-actif';
    }
    else if(this.etape === 'Localisation' || this.etape === 'Caracteristique' || this.etape === 'MOE') {
      return 'suivi-declaration-ouvrage-apparence-inactif';
    }
    else {
      return 'suivi-declaration-ouvrage-apparence-passe';
    }
  }

  /**
   * Méthode permettant de selectionner le style CSS à appliquer à l'icone du crayon dans le résumé de l'ouvrage pour la ligne Propriétaire.
   * La classe CSS est sélectionné à partir de l'étape courante de la déclaration de l'ouvrage.
   * Si l'étape courante est celle de la déclaration du proprietaire, la classe est 'crayon-actif'
   * Si l'étape courante est antérieur à la déclaration du proprietaire (Localisation, Caracteristique ou MOE), la classe est 'crayon-inactif'
   * Si l'étape courante est postérieur à la déclaration du proprietaire (declaration des autres acteurs ou de l'aquifere), la classe est 'crayon-passe'
   * 
   * @returns la classe CSS correspondant au context
   */
  choisirClasseCssProprietaireCrayon() {
    if(this.etape === 'Proprietaire') {
      return 'crayon-actif';
    }
    else if(this.etape === 'Localisation' || this.etape === 'Caracteristique' || this.etape === 'MOE') {
      return 'crayon-inactif';
    }
    else {
      return 'crayon-passe';
    }
  }

  /**
   * Méthode permettant de selectionner le style CSS à appliquer à la ligne Foreur du résumé de l'ouvrage.
   * La classe CSS est sélectionné à partir de l'étape courante de la déclaration de l'ouvrage.
   * Si l'étape courante est celle de la déclaration du foreur, la classe est 'suivi-declaration-ouvrage-apparence-actif'
   * Si l'étape courante est antérieur à la déclaration du foreur (Localisation, Caracteristique, MOE ou Proprietaire), la classe est 'suivi-declaration-ouvrage-apparence-inactif'
   * Si l'étape courante est postérieur à la déclaration du foreur (Aquifere), la classe est 'suivi-declaration-ouvrage-apparence-passe'
   * 
   * @returns la classe CSS correspondant au context
   */
  choisirClasseCssForeur() {
    if(this.etape === 'Foreur') {
      return 'suivi-declaration-ouvrage-apparence-actif';
    }
    else if(this.etape === 'Localisation' || this.etape === 'Caracteristique' || this.etape === 'MOE' || this.etape === 'Proprietaire') {
      return 'suivi-declaration-ouvrage-apparence-inactif';
    }
    else {
      return 'suivi-declaration-ouvrage-apparence-passe';
    }
  }

  /**
   * Méthode permettant de selectionner le style CSS à appliquer à l'icone du crayon dans le résumé de l'ouvrage pour la ligne Foreur.
   * La classe CSS est sélectionné à partir de l'étape courante de la déclaration de l'ouvrage.
   * Si l'étape courante est celle de la déclaration du foreur, la classe est 'crayon-actif'
   * Si l'étape courante est antérieur à la déclaration du foreur (Localisation, Caracteristique, MOE ou Proprietaire), la classe est 'crayon-inactif'
   * Si l'étape courante est postérieur à la déclaration du foreur (Aquifere), la classe est 'crayon-passe'
   * 
   * @returns la classe CSS correspondant au context
   */
  choisirClasseCssForeurCrayon() {
    if(this.etape === 'Foreur') {
      return 'crayon-actif';
    }
    else if(this.etape === 'Localisation' || this.etape === 'Caracteristique' || this.etape === 'MOE' || this.etape === 'Proprietaire') {
      return 'crayon-inactif';
    }
    else {
      return 'crayon-passe';
    }
  }

  /**
   * Méthode permettant de selectionner le style CSS à appliquer à la ligne Aquifere du résumé de l'ouvrage.
   * La classe CSS est sélectionné à partir de l'étape courante de la déclaration de l'ouvrage.
   * Si l'étape courante est celle de la déclaration du aquifere, la classe est 'suivi-declaration-ouvrage-apparence-actif'
   * Sinon, la classe est 'suivi-declaration-ouvrage-apparence-inactif'
   * 
   * @returns la classe CSS correspondant au context
   */
  choisirClasseCssAquifere() {
    if(this.etape === 'Aquifere') {
      return 'suivi-declaration-ouvrage-apparence-actif';
    }
    else {
      return 'suivi-declaration-ouvrage-apparence-inactif';
    }
  }

  /**
   * Méthode permettant de selectionner le style CSS à appliquer à l'icone du crayon dans le résumé de l'ouvrage pour la ligne Aquifere.
   * La classe CSS est sélectionné à partir de l'étape courante de la déclaration de l'ouvrage.
   * Si l'étape courante est celle de la déclaration de l'aquifere, la classe est 'crayon-actif'
   * Sinon, la classe est 'crayon-inactif'
   * 
   * @returns la classe CSS correspondant au context
   */
  choisirClasseCssAquifereCrayon() {
    if(this.etape === 'Aquifere') {
      return 'crayon-actif';
    }
    else {
      return 'crayon-inactif';
    }
  }

  /**
   * Méthode appelée quand l'utilisateur clic sur le le bouton "Suivant" depuis l'écran de saisie des caracteristiques de l'ouvrage.
   * La méthode permet de passer à l'étape suivante de la déclaration de l'ouvrage. 
   * Si le declarant n'est pas le MOE, l'étape suivante est celle de saisie des informations du MOE.
   * Si le declarant n'est pas le proprietaire, l'étape suivante est celle de saisie des informations du propriétaire.
   * Si le déclarant n'est pas le foreur, l'étape suivante est celle de saisie des informations du foreur.
   * Sinon, l'étape suivante est celle de saisie des informations de l'aquifere.
   */
  validerEtapeCaracteristique() {
    if(!this.isDeclarantMOE) {
      this.etape = 'MOE';
    }
    else if(!this.isDeclarantProprietaire) {
      this.etape = 'Proprietaire';
    }
    else if(!this.isDeclarantExploitant) {
      this.etape = 'Foreur';
    }
    else if(this.isEau) {
      this.etape = 'Aquifere';
    }
  }

  /**
   * Méthode appelée quand l'utilisateur clic sur le le bouton "Suivant" depuis l'écran de saisie des information du MOE.
   * La méthode permet de passer à l'étape suivante de la déclaration de l'ouvrage. 
   * Si le declarant n'est pas le proprietaire, l'étape suivante est celle de saisie des informations du propriétaire.
   * Si le déclarant n'est pas le foreur, l'étape suivante est celle de saisie des informations du foreur.
   * Sinon, l'étape suivante est celle de saisie des informations de l'aquifere.
   */
  validerEtapeMoe() {
    if(!this.isDeclarantProprietaire) {
      this.etape = 'Proprietaire';
    }
    else if(!this.isDeclarantExploitant) {
      this.etape = 'Foreur';
    }
    else if(this.isEau) {
      this.etape = 'Aquifere';
    }
  }

  /**
   * Méthode appelée quand l'utilisateur clic sur le le bouton "Suivant" depuis l'écran de saisie des information du proprietaire.
   * La méthode permet de passer à l'étape suivante de la déclaration de l'ouvrage. 
   * Si le déclarant n'est pas le foreur, l'étape suivante est celle de saisie des informations du foreur.
   * Sinon, l'étape suivante est celle de saisie des informations de l'aquifere.
   */
  validerEtapeProprietaire() {
    if(!this.isDeclarantExploitant) {
      this.etape = 'Foreur';
    }
    else if(this.isEau) {
      this.etape = 'Aquifere';
    }
  }

  /**
   * Méthode appelée quand l'utilisateur clic sur le le bouton "Suivant" depuis l'écran de saisie des information du foreur.
   * La méthode permet de passer à l'étape suivante de la déclaration de l'ouvrage : l'étape de saisie des informations de l'aquifere
   */
  validerEtapeForeur() {
    if(this.isEau) {
      this.etape = 'Aquifere';
    }
  }

  /**
   * Méthode appelée quand l'utilisateur clic sur la ligne Localisation du résumé de l'ouvrage.
   * Si l'utilisateur est à l'étape Caracteristique, MOE, Proprietaire, Foreur ou Aquifere, l'écran de saisie de la localisation s'affiche et l'etape courante est 
   * ramenée a 'Localisation'.
   * Sinon rien ne se passe
   */
  ouvrirLocalisation(ouvrage: Ouvrage) {
    if(this.etape === 'Caracteristique' ||this.etape === 'MOE' || this.etape === 'Proprietaire' || this.etape === 'Foreur' || this.etape === 'Aquifere') {
      this.ouvrageForm = ouvrage;
      this.etape = 'Localisation';
    }
  }

  /**
   * Méthode appelée quand l'utilisateur clic sur la ligne Caracteristique du résumé de l'ouvrage.
   * Si l'utilisateur est à l'étape MOE, Proprietaire, Foreur ou Aquifere, l'écran de saisie des caractéristiques de l'ouvrage s'affiche et l'etape courante est 
   * ramenée a 'Caracteristique'.
   * Sinon rien ne se passe
   */
  ouvrirCaracteristique(ouvrage: Ouvrage) {
    if(this.etape === 'MOE' || this.etape === 'Proprietaire' || this.etape === 'Foreur' || this.etape === 'Aquifere') {
      this.ouvrageForm = ouvrage;
      this.etape = 'Caracteristique';
    }
  }

  /**
   * Méthode appelée quand l'utilisateur clic sur la ligne MOE du résumé de l'ouvrage.
   * Si l'utilisateur est à l'étape Proprietaire, Foreur ou Aquifere, l'écran de saisie des informations du MOE s'affiche et l'etape courante est 
   * ramenée a 'MOE'.
   * Sinon rien ne se passe
   */
  ouvrirMoe(ouvrage: Ouvrage) {
    if(this.etape === 'Proprietaire' || this.etape === 'Foreur' || this.etape === 'Aquifere')
    this.ouvrageForm = ouvrage;
    this.etape = 'MOE';
  }

  /**
   * Méthode appelée quand l'utilisateur clic sur la ligne Proprietaire du résumé de l'ouvrage.
   * Si l'utilisateur est à l'étape Foreur ou Aquifere, l'écran de saisie des informations du proprietaire s'affiche et l'etape courante est 
   * ramenée a 'Proprietaire'.
   * Sinon rien ne se passe
   */
  ouvrirProprietaire(ouvrage: Ouvrage) {
    if(this.etape === 'Foreur' || this.etape === 'Aquifere') {
      this.ouvrageForm = ouvrage;
      this.etape = 'Proprietaire';
    }
  }

  /**
   * Méthode appelée quand l'utilisateur clic sur la ligne Forueur du résumé de l'ouvrage.
   * Si l'utilisateur est à l'étape Aquifere, l'écran de saisie des informations du foreur s'affiche et l'etape courante est ramenée a 'Foreur'.
   * Sinon rien ne se passe
   */
  ouvrirForeur(ouvrage: Ouvrage) {
    if(this.etape === 'Aquifere') {
      this.ouvrageForm = ouvrage;
      this.etape = 'Foreur';
    }
  }

  /**
   * Méthode appelée quand l'utilisateur clic sur la ligne Aquifere du résumé de l'ouvrage.
   */
  ouvrirAquifere(ouvrage: Ouvrage) {
    if(this.etape === 'Aquifere') {
      this.ouvrageForm = ouvrage;
      this.etape = 'Aquifere';
    }
  }
}
